import 'lightgallery';
import './front/functions';
import 'owl.carousel';
import "./front/choices/choices"

$(document).ready(function () {
    window.scrollToTop = function () {
        $('body, html').animate({ scrollTop: 0 }, 300);
    }

    $(document).on('click', '.readmore, .toggle', function () {
        if ($('.branddetails .toggle').hasClass('show')) {
            $('.branddetails .toggle').removeClass('show');
            $('a.readmore').show();
        } else {
            $('.branddetails .toggle').addClass('show');

            if (!$(this).hasClass('dont-remove')) {
                $('a.readmore').hide();
            }

            if ($(this).hasClass('readmore_register')) {
                const href = $(this).attr('href');
                window.axios.get(href);
            }
        }

        if ($(this).hasClass('readmore_register')) {
            return false;
        }
    });

    // news orderBy dropdown

    $('select#news_selector').change(function () {
        var value = $(this).val();
        var href = new URL(window.location.href);
        href.searchParams.set('page', 1);
        href.searchParams.set('sort', value);
        window.location = href
    });

    // faq

    $('.section.page.faq .item h3').click(function () {
        if ($(this).next().is(':hidden')) {
            $('.section.page.faq .item h3').removeClass('active').next().slideUp(200);
            $(this).toggleClass('active').next().slideDown(200);
        }
        else {
            $(this).toggleClass('active');
            $('.section.page.faq .item h3 + div').slideUp(200);
        }
    });

    // home ads

    if (window.modefabriek) {
        if (window.modefabriek.ads) {
            $('.adv .owl-carousel').owlCarousel({
                items: window.modefabriek.ads,
                loop: window.modefabriek.ads > 1,
                mouseDrag: window.modefabriek.ads > 1,
                touchDrag: window.modefabriek.ads > 1,
                pullDrag: window.modefabriek.ads > 1,
                margin: 10,
                dots: false,
                autoplay: true,
                autoplayHoverPause: true,
            });
        }
    }

    // home news

    $('.head .owl-carousel').owlCarousel({
        items: 1,
        dots: true,
        autoplay: true,
        autoplayHoverPause: true,
        loop: true,
    });

    // lookbook

    $('.lookbook .owl-carousel').owlCarousel({
        items: 1,
        autoplay: false,
        dots: false,
        nav: true,
        navText: []
    });

    // jobOffers

    $('.partners .owl-carousel').owlCarousel({
        loop: true,
        dots: false,
        nav: true,
        navText: [],
        autoplay: true,
        autoplayHoverPause: true,
        responsive: {
            0: {
                items: 4,
                margin: 10
            },
            751: {
                items: 7,
                margin: 20
            }
        }
    });

    //

    $('.lookbook').lightGallery({ selector: '.lightgallery', download: false, counter: false });
    // $('.owl-carousel').lightGallery({ selector: '.lightgallery', download: false, counter: true });
    // $('.box, .image').lightGallery({ selector: '.lightgallery', download: false, counter: false });

    $('.lg-sub-html .desc strong:first').addClass('active').next().show();

    $(document).on('click', '.lg-sub-html .desc strong', function () {
        if ($(this).next().is(':hidden')) {
            $('.lg-sub-html .desc strong').removeClass('active').next().slideUp(200);
            $(this).toggleClass('active').next().slideDown(200);
        }
        else {
            $(this).toggleClass('active');
            $('.lg-sub-html .desc strong').next().slideUp(200);
        }
    });

    //

    $(window).resize(function() {
        resizeEventPageVideo();
    });

    const resizeEventPageVideo = function() {
        setTimeout(() => {
            const eventPageVideo = $('.event-video-header video');

            if (!eventPageVideo) {
                return;
            }

            if (window.matchMedia("(max-width: 990px)").matches || window.matchMedia("(min-width: 1331px)").matches) {
                eventPageVideo.css({'max-height': ''});
                return;
            }

            const eventBlock = $('.event-blocks .item.one_third:first-child');
            const eventBlockImage = $('.event-blocks .item.one_third:first-child a.image');

            let outerHeight = Math.ceil(eventBlock.outerHeight() + eventBlockImage.outerHeight() + 9);

            eventPageVideo.css({'max-height': `${outerHeight}px`});
        }, 100);
    };

    resizeEventPageVideo();
});